export type SaldoTone = 'positive' | 'negative' | 'zero';

export function getSaldoTone(value: number): SaldoTone {
  if (value > 0) return 'positive';
  if (value < 0) return 'negative';
  return 'zero';
}

export function getSaldoTextColor(tone: SaldoTone): string {
  switch (tone) {
    case 'positive': return 'text-green-600';
    case 'negative': return 'text-red-600';
    case 'zero': return 'text-gray-600';
  }
}

export function getSaldoBgColor(tone: SaldoTone): string {
  switch (tone) {
    case 'positive': return 'bg-green-50 border-green-200';
    case 'negative': return 'bg-red-50 border-red-200';
    case 'zero': return 'bg-gray-50 border-gray-200';
  }
}
